import { gql } from '$lib/apollo';

export const ADD_COACH_FAQ = gql`
  mutation AddCoachFaq($input: AccountFaqCreateInput!) {
    accountFaqCreate(input: $input) {
      result {
        id
        question
        answer
        position
      }
    }
  }
`;

export const EDIT_COACH_FAQ = gql`
  mutation EditCoachFaq($input: AccountFaqUpdateInput!) {
    accountFaqUpdate(input: $input) {
      result {
        id
        question
        answer
        position
      }
    }
  }
`;

export const REMOVE_COACH_FAQ = gql`
  mutation RemoveCoachFaq($input: AccountFaqDeleteInput!) {
    accountFaqDelete(input: $input) {
      result
    }
  }
`;
